import script from "./MakeIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./MakeIndex.vue?vue&type=script&setup=true&lang=js"

import "./MakeIndex.vue?vue&type=style&index=0&id=1aad8239&lang=less&scoped=true"
import "./MakeIndex.vue?vue&type=style&index=1&id=1aad8239&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aad8239"]])

export default __exports__